var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21 1.01a9.91 9.91 0 0 1-2.855 1.39A4.073 4.073 0 0 0 11 5.128v.909a9.69 9.69 0 0 1-8.182-4.119S-.818 10.1 7.364 13.737A10.582 10.582 0 0 1 1 15.555c8.182 4.545 18.182 0 18.182-10.455-.001-.253-.025-.506-.073-.754A7.018 7.018 0 0 0 21 1.009Z",
    stroke: "#F77A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTwitter;